import React, { createContext, useContext, useEffect } from "react" 
import { Outlet, useParams, useNavigate } from "react-router-dom"
import { Plus } from "lucide-react"
import { useAppCtx, appStore } from "lib/state";
import { queryTools, cn } from "lib/utils";
import { CollectionLoader, UnitTitleBlock } from "lib/components"
import { User } from "." 

const UserContext = createContext({})
export const useUserCtx = () => useContext(UserContext)

export default function UserProvider({ className="" }:{ className?:string }){
  const navigate = useNavigate()
  const { uid } = useParams()
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()
  
  const { data:_Users } = queryTools.resource.parseQueryForApi("user.findAll", {})
  const { data:_User } = queryTools.resource.parseQueryForApi("user.findById", { _id: uid }, { enabled: !!uid })
  const saveFn = queryTools.resource.save(["user.all"])
  
  const saveUser = () => {
    saveFn.mutate({ resource: "client", data: _User._id } )
  }

  return (
    <UserContext.Provider value={{ }}>
      <div className={cn("w-full pt-6", className)}>
        <UnitTitleBlock className="left-[10px] w-[calc(100%+10px)]" title="user manager">
          <Plus className="size-5 cursor-pointer stroke-1 stroke-gray-100" onClick={saveUser} />
        </UnitTitleBlock>

        <div className="w-full flex items-stretch gap-4">
          
          <div className="w-2/12 flex border border-solid border-slate-700 h-[40rem] overflow-auto scrollbar">
            <CollectionLoader 
              collection={_Users}
              selectFn={(item:any) => navigate(`/user/${item._id}`)}
              selectProp="_id"
              labelProp="name"
              className="w-full"
            />
          </div>

          <div className="w-10/12">
            { _User !== undefined && ( <User /> )}
          </div>

        </div>
    
      </div>
    </UserContext.Provider>
  )
}